// extracted by mini-css-extract-plugin
export default {"wsp":"WspAdd_wsp__GVMXt"};